import React from 'react';
import PairOfCards from '../../../../components/PairOfCards';
import CashSvg from '../../../Dashboard/components/Svg/CashSvg';
import TournamentSvg from '../../../Dashboard/components/Svg/TournamentSvg';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { allButtons } from '../../helpers/allButtons';
import './Quiz.scss';

export function Quiz({ data: { title, img, imgAlt, text, cards, link, access, locked } }) {
  const buttonType = getButtonType(locked, access);

  return (
    <div className="Quiz">
      <h3 className="Quiz__title">{title}</h3>
      <div className="Quiz__img-row">
        <div className="Quiz__img-block">
          {img && (
            <img src={img} alt={imgAlt} />
          )}
        </div>
        <PairOfCards cards={cards} className="Quiz__cards" />
      </div>
      <p className="Quiz__type">
        {text.type === 'cash' ? <CashSvg /> : <TournamentSvg />}
        {capitalizeFirstLetter(text.type)}
      </p>
      <dl className="Quiz__list">
        <dt>Stack:</dt>
        <dd>{text.stack}</dd>
        <dt>Blinds:</dt>
        <dd>{text.blinds}</dd>
        <dt>Position:</dt>
        <dd>{text.pos}</dd>
        <dt>Opp Pos:</dt>
        <dd>{text.opp_position}</dd>
      </dl>
      <div className="Quiz__btn">
        {allButtons[buttonType](link)}
      </div>
    </div>
  );
}

function getButtonType(locked = false, access) {
  if (!locked) return 'standard'
  if (access !== 'pcp') return 'premium'
  return 'standard'
}
